// extracted by mini-css-extract-plugin
module.exports = {"contents":"Contact_contents__Ag4HK","content":"Contact_content__3flHh","title":"Contact_title__wQh01","text":"Contact_text__24MJ_","contactForm":"Contact_contactForm__3ef_C"};